<template>
  <card class="company" @click="cardClick" :footer="true">
    <div class="container">
      <div class="top-bar" v-if="isActive === true">
        <p class="vote-text">54 Votes so far</p>
        <div class="active-container">
          <div class="active-mark">Active</div>
          <p class="active-text">36 hours remain</p>
        </div>
      </div>
      <div class="top-bar" v-else>
        <p class="comment-text">5 Comments</p>
        <p class="proposed-text">Proposed</p>
      </div>

      <div :class="isActive ? 'text-container-active' : 'text-container'">
        <p class="title">Disaster Relief Donation</p>
        <div class="text-con"><div class="content">
          A donation of $1,000 on behalf
          of the HireVibes DAO to the relief
          efforts of the forest fires in Southerndamnsgbhdjhnmasghdkjhasghdhjkasghjkdgajhsgdjhasghjdgsajhdgjhsagdhjsa...
        </div></div>
      </div>

    </div>
    <template slot="footer">
      <single-section>
        <template slot="section">View proposal details
        </template>
      </single-section>
    </template>
  </card>
</template>

<script>
import Card from '@/components/general/card'
import SingleSection from '@/components/general/single-section'
import HvImage from '@/components/general/image'

export default {
  name: 'ProposalCard',
  components: {
    Card,
    SingleSection,
    HvImage
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cardClick () {
      this.$router.push('/proposal/pakistan')
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
}
.top-bar{
display: flex;
  justify-content: space-between;
}

.vote-text{
  color: #000;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.active-mark{
  border-radius: 5px;
  background: #ADF6B1;
  padding: 6px 16px;
  color: #0A7B10;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.active-text{
  color: #0A7B10;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top:4px ;
}
.comment-text{
  color: #000;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.proposed-text{
  color: #000;
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}

.title{
  color: #000;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
}

.text-container{
  margin-top: 40px;
}

.text-container-active{
  margin-top: 20px;
}

.text-con {
  max-height: 80px; /* Set the maximum height for the container */
  overflow: hidden; /* Hide any content that exceeds the maximum height */
  margin-top: 10px;
  color: #000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.content {
  white-space: normal; /* Allow the text to wrap normally */
  display: -webkit-box; /* For compatibility with Safari/WebKit browsers */
  -webkit-box-orient: vertical; /* Set the layout direction to vertical */
  -webkit-line-clamp: 3; /* Number of lines to show before adding ellipsis */
  line-clamp: 3; /* Number of lines to show before adding ellipsis */
  overflow: hidden; /* Hide any content that exceeds the specified number of lines */
}
</style>



// WEBPACK FOOTER //
// src/components/dao-community/proposal-card.vue